import { jsx as _jsx } from "react/jsx-runtime";
export default function ErrorMessage({ className, children, ...props }) {
    return (_jsx("div", { ...props, className: ['alert alert-danger', className].filter(Boolean).join(' '), role: "alert", children: children }));
}
